const GROUP_TYPE_USER = 'USER';
const GROUP_TYPE_ADMIN = 'ADMIN';
const GROUP_TYPE_NOT_FOUND = 'NOT_FOUND';

const FIELD_TYPE_FILE = 'file';
const FIELD_TYPE_TEXT = 'text';
const FIELD_TYPE_TOGGLE = 'toggle';
const FIELD_TYPE_DROPDOWN = 'dropdown';
const FIELD_TYPE_PASSWORD = 'password';
const FIELD_TYPE_DATE_RANGE = 'date-range';

export {
  GROUP_TYPE_USER,
  GROUP_TYPE_ADMIN,
  GROUP_TYPE_NOT_FOUND,
  // field
  FIELD_TYPE_TEXT,
  FIELD_TYPE_FILE,
  FIELD_TYPE_TOGGLE,
  FIELD_TYPE_DROPDOWN,
  FIELD_TYPE_PASSWORD,
  FIELD_TYPE_DATE_RANGE,
};
